import { useEffect, useRef, useState } from "react";
// facility icons
import { RiFridgeLine } from "react-icons/ri";
import { FaWater } from "react-icons/fa";
import { TbAirConditioning } from "react-icons/tb";
import { CiWifiOn } from "react-icons/ci";
import { MdOutlineFreeBreakfast } from "react-icons/md";
import { PiTelevisionSimpleThin } from "react-icons/pi";
import { PiBuildingApartmentLight } from "react-icons/pi";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { LuBedDouble } from "react-icons/lu";
import { LuBedSingle } from "react-icons/lu";
import { CreateDivBack } from "./createdivfromback";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

const facilityIconData = [
  { icon: PiTelevisionSimpleThin, label: "Television" },
  { icon: RiFridgeLine, label: "Refrigerator" },
  { icon: FaWater, label: "Geyser" },
  { icon: TbAirConditioning, label: "Air Conditioning" },
  { icon: CiWifiOn, label: "Free Wi-Fi" },
  { icon: MdOutlineFreeBreakfast, label: "Free Breakfast" },
  { icon: PiBuildingApartmentLight, label: "Small Room" },
  { icon: PiBuildingApartmentLight, label: "Big Room" },
  { icon: LuBedDouble, label: "Double Bed" },
  { icon: LuBedSingle, label: "Single Bed" },
];

export const RoomFacility = () => {
  const [roomID, setRoomID] = useState("");
  const [mainImage, setMainImage] = useState(null);
  const [thumbnails, setThumbnails] = useState([]);
  const [roomFacility, setRoomFacility] = useState([]);
  const [roomData, setRoomData] = useState([]);
  const [facilityIcon, setFacilityIcon] = useState([]);
  const [roomName, setRoomName] = useState("");
  const [roomDataTable, setRoomDataTable] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    setFacilityIcon(facilityIconData);
  }, []);

  // Fetch all room data initially
  useEffect(() => {
    fetch("https://api.bgmhotel.com/roomName")
      .then((response) => response.json())
      .then((json) => {
        setRoomData(json);
      })
      .catch((error) => {
        console.error("Error fetching rooms:", error);
      });
  }, []);
  // set room price and name by id

  // useEffect to trigger the fetch when roomID or roomName changes
  useEffect(() => {
    if (roomID) {
      fetchRoomByIdOrName("id", roomID);
    } else if (roomName) {
      fetchRoomByIdOrName("name", roomName);
    }
  }, [roomID, roomName]); // This runs when roomID or roomName changes
  // Fetch room by ID or name when selected
  const fetchRoomByIdOrName = (type, value) => {
    fetch(`https://api.bgmhotel.com/roomName/${value}`)
      .then((response) => response.json())
      .then((json) => {
        setRoomFacility([json]);
      })
      .catch((error) => {
        console.error("Error fetching rooms:", error);
      });
  };
  // thumnail adding
  // const handleFileChange = (e) => {
  //   const selectedFiles = Array.from(e.target.files);

  //   // Extract only the `name` property from each file
  //   const fileNames = selectedFiles.map((file) => file.name);

  //   // console.log(fileNames); // Output: Array of file names

  //   // Limit to 4 files and update state with the names
  //   const updatedThumbnails = [...thumbnails, ...fileNames].slice(0, 4);
  //   setThumbnails(updatedThumbnails);
  // };

  const handleThumbnailChange = (event) => {
    const selectedFiles = Array.from(event.target.files);

    // Generate object URLs for preview
    const newThumbnails = selectedFiles.map((file) => ({
      url: URL.createObjectURL(file),
      file,
    }));

    // Combine existing and new thumbnails, limiting to 4
    const updatedThumbnails = [...thumbnails, ...newThumbnails].slice(0, 4);
    setThumbnails(updatedThumbnails);
  };

  // Remove a thumbnail by index
  const removeThumbnail = (index) => {
    const updatedThumbnails = thumbnails.filter((_, i) => i !== index);
    setThumbnails(updatedThumbnails);
  };

  // set main image
  // const resolveImagePath = (path) => {
  //   // Prepend the base URL if needed
  //   return path.startsWith("")
  //     ? path.replace("", "../src/assets/imges/")
  //     : path;
  // };

  // const resolveImagePath = (path) => {
  //   // If the path is a URL, return it as is
  //   if (path.startsWith("http") || path.startsWith("https")) {
  //     return path;
  //   }

  //   // If the path is a local file path (from FileReader), return it
  //   if (path.startsWith("data:image")) {
  //     return path;
  //   }

  //   // Fallback to public folder (for paths starting with '/')
  //   if (path.startsWith("")) {
  //     return `${process.env.PUBLIC_URL}${path}`;
  //   }

  //   // Default to an image inside src/assets/imges/
  //   return `../src/assets/imges/${path}`;
  // };

  // remove thumbnail
  // const removeFile = (index) => {
  //   const updatedThumbnails = thumbnails.filter((_, i) => i !== index);
  //   setThumbnails(updatedThumbnails);
  // };
  // main image
  // const handleMainImageChange = (e) => {
  //   // setMainImage(e.target.files[0]);
  //   //   setMainImage(e.target.value);
  //   setMainImage(e.target.files[0].name);
  //   //   setMainImage(window.location.href + "/" + e.target.files[0].name);
  // };

  // submit function working code

  // const submitRoomFacility = (event) => {
  //   event.preventDefault();

  //   const formData = new FormData(event.target);

  //   const selectedFacilities = Array.from(
  //     event.target.querySelectorAll("input[name='facility']:checked")
  //   ).map((checkbox) => {
  //     const facility = facilityIcon.find(
  //       (facility) => facility.label.toLowerCase() === checkbox.value
  //     );
  //     return { label: facility.label, icon: facility.icon.name };
  //   });

  //   const price = {
  //     icon: FaIndianRupeeSign.name,
  //     label: formData.get("price"),
  //   };

  //   const data = {
  //     id: formData.get("id"),
  //     roomType: formData.get("roomType"),
  //     mainImage: mainImage,
  //     price: price,
  //     facilities: selectedFacilities,
  //     thumbnail: thumbnails,
  //   };

  //   fetch("https://api.bgmhotel.com/rooms", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(data),
  //   })
  //     .then((response) => response.json())
  //     .then((result) => {
  //       console.log("Response from backend:", result);
  //       navigate("/");
  //     })
  //     .catch((error) => {
  //       console.error("Error submitting form:", error);
  //     });
  // };

  // submit function new code

  const submitRoomFacility = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);

    // Process facilities
    const selectedFacilities = Array.from(
      event.target.querySelectorAll("input[name='facility']:checked")
    ).map((checkbox) => {
      const facility = facilityIcon.find(
        (facility) => facility.label.toLowerCase() === checkbox.value
      );
      return { label: facility.label, icon: facility.icon.name };
    });
    formData.append("facilities", JSON.stringify(selectedFacilities));

    // Process price
    const price = {
      icon: FaIndianRupeeSign.name,
      label: formData.get("price"), // Fetch the price input value
    };
    formData.delete("price"); // Ensure no duplicate `price` key
    formData.append("price", JSON.stringify(price));

    // Handle multiple thumbnail images
    const thumbnails = event.target.querySelector(
      "input[name='thumbnail']"
    ).files;
    Array.from(thumbnails).forEach((file) => {
      formData.append("thumbnail", file); // Append each file only once
    });

    // Send the data
    try {
      const response = await fetch("https://api.bgmhotel.com/rooms", {
        method: "POST",
        body: formData, // Send FormData directly
      });

      const result = await response.json();
      console.log("Response from backend:", result);
      if (response.ok) {
        alert("Room saved successfully!");
        // navigate("/");
      } else {
        alert("Failed to save the room.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while saving the room.");
    }
  };

  // new mail image file upload function
  // const inputRef = useRef(null);
  // const [image, setImage] = useState("");
  // const handleimageclick = () => {
  //   inputRef.current.click();
  // };

  const handleimagechange = (event) => {
    const file = event.target.files[0];
    // URL.createObjectURL(file);
    console.log("file====>", file);
    setMainImage(URL.createObjectURL(file));
  };

  return (
    <>
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
          >
            Add Room Facilities &nbsp;
            <sup>Add Room Facilities like AC, Fridge, TV, etc.</sup>
          </button>
        </h2>
        <div
          id="collapseTwo"
          className="accordion-collapse collapse"
          data-bs-parent="#adminPanelRoomDetail"
        >
          <div className="accordion-body">
            <form onSubmit={submitRoomFacility}>
              <div className="input-group py-2">
                <div className="input-group-text">Room ID</div>
                <select
                  name="id"
                  className="form-select"
                  value={roomID}
                  required
                  onChange={(e) => {
                    setRoomID(e.target.value);
                    fetchRoomByIdOrName("id", e.target.value); // Assuming this function exists
                  }}
                >
                  <option value="">Select Room Type</option>
                  {roomData.map((room, index) => (
                    <option key={index} value={room.id}>
                      {room.id}
                    </option>
                  ))}
                </select>
              </div>

              {roomFacility.map((faci, index) => (
                <div key={index}>
                  <div className="input-group py-2">
                    <span className="input-group-text">Room Type</span>
                    <input
                      name="roomType"
                      type="text"
                      className="form-control"
                      value={faci?.name}
                      readOnly={true}
                    />
                  </div>
                  <div className="input-group py-2">
                    <span className="input-group-text">Price Per Night</span>
                    <div className="input-group-text bg-warning">
                      <LiaRupeeSignSolid />
                    </div>
                    <input
                      name="price"
                      type="text"
                      className="form-control"
                      value={faci?.price}
                      readOnly={true}
                    />
                  </div>
                </div>
              ))}

              {/* Main Image Input */}
              <div className="input-group mb-3">
                <input
                  type="file"
                  name="mainImage"
                  required
                  // onChange={handleMainImageChange}
                  onChange={handleimagechange}
                  className="form-control"
                  placeholder="mainimage"
                />
              </div>
              {mainImage && (
                <img
                  src={mainImage}
                  alt=""
                  style={{ height: "100px", width: "100px" }}
                /> || ""
              )}

              {/* thumbnail image add */}
              {/* File Input and Upload Button */}
              <div className="input-group mb-3">
                <input
                  type="file"
                  className="form-control"
                  // onChange={(e) => {
                  //   if (thumbnails.length < 4) {
                  //     handleFileChange(e);
                  //   } else {
                  //     alert("You can only upload up to 4 files.");
                  //   }
                  // }}
                  onChange={(e) => {
                    if (thumbnails.length < 4) {
                      handleThumbnailChange(e);
                    } else {
                      alert("You can only upload up to 4 files.");
                    }
                  }}
                  multiple
                  accept="image/*" // Restrict file types to images
                  name="thumbnail"
                />
                {/* <button
                    className="input-group-text"
                    type="button"
                    onClick={handleUpload}
                    disabled={thumbnails.length === 0}
                  >
                    Upload Thumbnail
                  </button> */}
              </div>
              {/* Thumbnail Preview */}
              
              <div className="thumbnail-preview">
                <h6>Uploaded Thumbnail</h6>
                {thumbnails.length > 0 ? (
                  thumbnails.map((thumb, index) => (
                    <div
                      key={index}
                      className="thumbnail-item"
                      style={{
                        margin: "10px",
                        display: "inline-block",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={thumb.url}
                        alt={`Thumbnail ${index + 1}`}
                        // onError={(e) => {
                        //   e.target.onerror = null; // Prevent infinite loop
                        //   e.target.src =
                        //     "https://api.bgmhotel.com/default-placeholder.png"; // Fallback image
                        // }}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          margin: "10px",
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-danger btn mt-2"
                        onClick={() => removeThumbnail(index)}
                      >
                        Delete
                      </button>
                    </div>
                  ))
                ) : (
                  <p>No thumbnails uploaded yet.</p>
                )}
              </div>

              {/* Upload Available Facilities */}
              <div className="card">
                <div className="card-header">
                  <h6>Available Facilities</h6>
                </div>
                <div className="card-body">
                  <div className="col-12">
                    <div className="row">
                      {facilityIcon.map((facility, index) => (
                        <label
                          key={index}
                          className="col d-flex align-items-center py-2"
                        >
                          <input
                            type="checkbox"
                            className="me-2"
                            name="facility"
                            value={facility.label.toLowerCase()} // Use the label as the value
                          />
                          <div className="col-auto">
                            <facility.icon size={20} />
                          </div>
                          <div className="col" style={{ whiteSpace: "nowrap" }}>
                            &nbsp; <span>{facility.label}</span>
                            {/* Wrap the label in a span */}
                          </div>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                {/* <div className="card-footer">
                    <button className="btn btn-warning">Submit Facility</button>
                  </div> */}
              </div>
              <button
                // className="customButton col-md-3 col-sm-12 col-12 mt-4"
                className=" btn btn-primary-custom col-md-3 col-sm-12 col-12 mt-4 animated slideInLeft"
                type="submit"
              >
                Add Room Facility
              </button>
              {/* 
              <button
                className="customButton col-md-3 col-sm-12 col-12 mt-4"
                type="submit"
              >
                Add Room Facility
              </button> */}
            </form>

            {/* image upload working code */}
            {/* <div onClick={handleimageclick}>
              <img src="" alt="" />
              {image ? <img src={image} alt="" /> : <img src="" alt="" />}
              <input
                type="file"
                ref={inputRef}
                style={{ display: "none" }}
                onChange={handleimagechange}
              />
            </div> */}
          </div>
        </div>
        {/* <CreateDivBack /> */}
      </div>
    </>
  );
};
